import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=8375b878&scoped=true&"
import script from "./customerList.vue?vue&type=script&lang=js&"
export * from "./customerList.vue?vue&type=script&lang=js&"
import style0 from "./customerList.vue?vue&type=style&index=0&id=8375b878&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8375b878",
  null
  
)

component.options.__file = "customerList.vue"
export default component.exports